import React, { useEffect, useState } from "react";
import { GetAssignedFacilitiesList } from "adminApi/AssignRoomFacilitiesApi/AssignRoomFacilities";

const CheckboxGroup = ({ values, setValues, facilityOptions = [], field }) => {
    const [facilities, setFacilities] = useState([]);
    const [selectedFacilities, setSelectedFacilities] = useState([]);

    /* ---------------- LOAD OPTIONS ---------------- */
    useEffect(() => {
        setFacilities(Array.isArray(facilityOptions) ? facilityOptions : []);
    }, [facilityOptions]);

    /* ---------------- SYNC FROM PARENT (EDIT SAFE) ---------------- */
    useEffect(() => {
        if (Array.isArray(values.facility_id)) {
            setSelectedFacilities(values.facility_id);
        }
    }, [values.facility_id]);

    /* ---------------- OPTIONAL: FETCH ASSIGNED (ONLY IF NEEDED) ---------------- */
    useEffect(() => {
        // Only fetch if parent has NOT already provided facility_id
        if (!values.room_type) return;
        if (Array.isArray(values.facility_id) && values.facility_id.length) return;

        const fetchAssigned = async () => {
            try {
                const res = await GetAssignedFacilitiesList(values.room_type);
                const list = res?.data?.data || [];
                const ids = list.map(item => item.facility_id);

                setSelectedFacilities(ids);
                setValues(prev => ({ ...prev, facility_id: ids }));
            } catch (err) {
                console.error("Facility fetch error:", err);
            }
        };

        fetchAssigned();
    }, [values.room_type]); // 👈 NO facilityOptions dependency

    /* ---------------- TOGGLE SINGLE ---------------- */
    const toggleFacility = (id) => {
        const updated = selectedFacilities.includes(id)
            ? selectedFacilities.filter(fid => fid !== id)
            : [...selectedFacilities, id];

        setSelectedFacilities(updated);
        setValues(prev => ({ ...prev, facility_id: updated }));
    };

    /* ---------------- SELECT ALL ---------------- */
    const toggleSelectAll = (e) => {
        const allIds = e.target.checked
            ? facilities.map(f => f.id)
            : [];

        setSelectedFacilities(allIds);
        setValues(prev => ({ ...prev, facility_id: allIds }));
    };

    const isAllSelected =
        facilities.length > 0 &&
        selectedFacilities.length === facilities.length;

    /* ---------------- RENDER ---------------- */
    return (
        <div className={field.fieldSize || "col-12"}>
            <div
                className="row g-3 p-3 rounded-3 mt-2"
                style={{ border: "0.5px dashed var(--primary-color)" }}
            >
                {/* Select All */}
                <div className="col-12 d-flex align-items-center">
                    {field.label && (
                        <label className="form-label text-muted m-0 me-2">
                            {field.label}
                        </label>
                    )}
                    {field.required && <span className="text-danger me-2">*</span>}

                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isAllSelected}
                        onChange={toggleSelectAll}
                    />
                </div>

                {/* Facility Items */}
                {facilities.map((facility) => (
                    <div
                        key={facility.id}
                        className="col-md-4 col-lg-3 col-xxl-2 col-sm-6 col-12"
                    >
                        <div className="form-check p-3 border rounded-3 shadow-sm h-100 d-flex align-items-center">
                            <input
                                id={`facility-${facility.id}`}
                                type="checkbox"
                                className="form-check-input me-3"
                                checked={selectedFacilities.includes(facility.id)}
                                onChange={() => toggleFacility(facility.id)}
                            />
                            <label
                                htmlFor={`facility-${facility.id}`}
                                className="form-check-label mb-0 fw-medium"
                            >
                                {facility.name}
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CheckboxGroup;
